import { Y } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Artikel } from '../../store/models/artikel';
import { ArtikelBild } from '../../store/models/artikelbild';
import { ArtikelbilderService } from '../shared/artikelBilder.service';
import { ArtikelsService } from '../shared/artikels.service';
import $ from 'jquery'; //Eric
import { ArtikelzubehoerComponent } from '../artikelzubehoer/artikelzubehoer.component';
import { ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'kkis-app-artikel-quick-view1',
    templateUrl: './artikel-quick-view1.component.html',
    styleUrls: ['./artikel-quick-view1.component.scss'],
    encapsulation: ViewEncapsulation.None //https://stackoverflow.com/questions/46403698/css-values-not-applying-on-dynamically-injected-html-div-elements-in-angular-4
})
export class ArtikelQuickView1Component implements OnInit {

    // Menge
    menge: FormControl;

    // Artikel
    artikel: any;
    // artikel: Artikel.IArtikelDto;

    selectedArtikel: any;

    bestand: number;
    preis: number;

    preis_netto: string;
    preis_brutto: string;

    artikelBilder: ArtikelBild.IArtikelBilderDto;
    matrixArtikelBilder: ArtikelBild.IArtikelBilderDto;

    // Matrix-Artikel
    groessen: Artikel.IArtikelListSettingGroessenDto[] = [];
    farben: Artikel.IArtikelListSettingFarbenDto[] = [];

    selXid: number;
    selYid: number;

    selectedGroesse: Artikel.IArtikelListSettingGroessenDto;
    selectedFarbe: Artikel.IArtikelListSettingFarbenDto;

    // Messages
    nichtAufLager: string;

    // Images (fraom Database)
    selectedImgFile: BlobPart[];
    // imgFiles: BlobPart[][] = [];
    imgFiles: any[] = [];

    // (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // number available dropdownboxes to calculate the size of them (groessen, farben, bestand)
    dropdownboxesWidth = 100;

    // Utils
    isLoading: boolean = true;
    isLoadingMatrix: boolean = false;
    isValid: boolean = true;
    isMatrixArtikel: boolean = false;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ArtikelQuickView1Component>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private artikelsService: ArtikelsService,
        private artikelBilderService: ArtikelbilderService
    ) { }

    ngOnInit(): void {

        this.artikel = this.data.artikel;

        console.log(this.artikel);
        
        if (this.artikel.matrixArtikel_JN == 'J') {
            this.isMatrixArtikel = true;
        }

        
        // calculate number of visible dropdownboxes
        var nDropdownboxes = 3;
        this.dropdownboxesWidth = 100/nDropdownboxes;


        if (this.isMatrixArtikel) {

            this.isLoadingMatrix = true;

            this.artikelsService.getListArtikelMatrixForArtikel(this.artikel.id).subscribe(res => {

                if (res) {
                    this.artikel.artikelMatrixList = Object.assign([], res);        //https://stackoverflow.com/questions/44808882/cloning-an-array-in-javascript-typescript

                    if (this.artikel.artikelMatrixList && this.artikel.artikelMatrixList.length > 0) {

                        this.artikel.artikelMatrixList.forEach(x => {
            
                            let g = {} as Artikel.IArtikelListSettingGroessenDto;
                            let f = {} as Artikel.IArtikelListSettingFarbenDto;
            
                            if (!this.groessen.some(a => a.groesse_Id === x.x_Id)) {
                                g.artikelId = x.id;
                                g.groesse_Id = x.x_Id;
                                g.groesse_Wert = x.x_Wert;
            
                                this.groessen.push(g);
                            }
            
                            if (!this.farben.some(a => a.farbe_Id === x.y_Id)) {
                                f.artikelId = x.id;
                                f.farbe_Id = x.y_Id;
                                f.farbe_Wert = x.y_Wert;
            
                                this.farben.push(f);
                            }
                        });
            
                        if (this.groessen.length === 1) {
                            this.selectedGroesse = this.groessen[0];
                            this.selXid = this.selectedGroesse.groesse_Id;
                        } else if (this.groessen.length > 1 && !this.selectedGroesse) {
                            this.isValid = false;
                        }
            
                        if (this.farben.length === 1) {
                            this.selectedFarbe = this.farben[0];
                            this.selYid = this.selectedFarbe.farbe_Id;
                        } else if (this.farben.length > 1 && !this.selectedFarbe) {
                            this.isValid = false;
                        }

                        if (this.farben.length > 0) {
                            // nDropdownboxes += 1;
                            // this.dropdownboxesWidth = 100/nDropdownboxes;
                        } 
                        
                        if (this.groessen.length > 0) {
                            // nDropdownboxes += 1;
                            // this.dropdownboxesWidth = 100/nDropdownboxes;
                        }
                    }

                    this.isLoadingMatrix = false;
                } else {
                    this.isLoadingMatrix = false;
                }
            });
        }

        //if (this.artikel.anzahlZubehör > 1) {
            this.artikelsService.getListArtikelZubehoerForArtikel(this.artikel.id).subscribe(res => {
                this.artikel.artikelZubehörList = res;

                //gibt es Zubehör?
                if (res.length > 0) {

                    $('#container_zubehoer').show();

                    this.artikel.artikelZubehörList.forEach(function (item) {
                        //console.log(item.nr);

                        $('#div_zubehoer').append('<div class="zub_item" data-id="'+item.id+'">'+item.nr+'<div>');
                        //$('#div_zubehoer').append('<button mat-flat-button color="accent" onClick="MyCustomNamespace.openDialog()">In den Warenkorb</button>');
                        $('#div_zubehoer').append('<button type="button" onClick="testFunc()">Click to open</button>');

                    });
                } else {
                    $('#container_zubehoer').hide();
                }
                
                $('.zub_item').on("click", function () {
                    alert('clicked'+ $(this).attr('data-id'));
                    //zum Warenkorb hinzufügen

                });
            });
        //}

        if (this.artikel.anzahlBilder > 1) {
            this.artikelBilderService.getListArtikelBilder(this.artikel.id).subscribe(res => {
                this.artikelBilder = res;
            });
        }

        this.bestand = this.artikel.bestand;

        this.preis = this.artikel.bruttoPreis_E1;

        this.selectedImgFile = this.artikel.bild;

        if (this.bestand < 1) {
            this.isValid = false;
        }
        
        if (this.bestand > 0) {
            // nDropdownboxes += 1;
            // this.dropdownboxesWidth = 100/nDropdownboxes;
        }

        this.nichtAufLager = "NICHT AUF LAGER";

        this.menge = new FormControl(1, [Validators.required, Validators.min(0), Validators.max(this.bestand)])

        console.log('Set loading to false');
        this.isLoading = false;

        this.preis_netto = (this.artikel.preisNetto).toFixed(2);
        this.preis_brutto = (this.artikel.preisBrutto).toFixed(2);

    }
    
    onGroesseChanged(event) {
        if (event.value.groesse_Id != null && event.value.groesse_Id > 0) {
            this.selXid = event.value.groesse_Id;
            this.getMatrixArtikel();
        }
    }

    onFarbeChanged(event) {
        if (event.value.farbe_Id != null && event.value.farbe_Id > 0) {
            this.selYid = event.value.farbe_Id;
            this.getMatrixArtikel();
        }
    }


    getMatrixArtikel() {
        if (this.selXid > 0 && this.selYid > 0) {
            if (this.artikel.artikelMatrixList != null) {
                var matrixArtikel = this.artikel.artikelMatrixList.filter(x => x.x_Id === this.selXid && x.y_Id === this.selYid);
                this.selectedArtikel = matrixArtikel[0];

                this.bestand = this.selectedArtikel.bestand;

                this.artikelBilderService.getListMatrixArtikelBilder(matrixArtikel[0].id).subscribe(res => {
                    this.selectedImgFile = res[0].bild;
                    this.artikelBilder = res;
                });
            }

            this.isValid = true;

        } else if (this.selYid > 0  && (this.selXid === 0 || this.selXid == undefined || this.selXid == null)) {
            if  (this.artikel.artikelMatrixList != null) {
                var matrixArtikel = this.artikel.artikelMatrixList.filter(x => x.y_Id === this.selYid);
                this.selectedArtikel = matrixArtikel[0];
                this.artikelBilderService.getListMatrixArtikelBilder(matrixArtikel[0].id).subscribe(res => {
                    this.selectedImgFile = res[0].bild;
                    this.artikelBilder = res;
                });
            }
        }
    }

    onChangeMenge(event) {
        /*
        if (event.target.value <= 0 || event.target.value > this.bestand) {
            this.isValid = false;
        } else {
            this.isValid = true;
        }
            */

        //gibt es staffelpreise?
        this.getvaluefromstaffel(event.target.value);
        
    }

    getErrorMessageRequired(prop: string) {
        return prop + ' ist erforderlich.'
    }

    getErrorMessageMenge() {
        if (this.menge.hasError('required')) {
            return 'Menge ist erforderlich.'
        }

        if (this.menge.hasError('min')) {
            return 'Der Wert muss > 0 sein.'
        }

        if (this.menge.hasError('max')) {
            return 'Der Wert muss < ' + (this.bestand + 1) + ' sein.'
        }
    }

    onAddToWarenkorb() {
        this.dialogRef.close({
            artikel: this.selectedArtikel == null ? this.artikel : this.selectedArtikel,
            menge: this.menge.value,
            farbe: this.selectedFarbe,
            groesse: this.selectedGroesse,
            isMatrixArtikel: this.isMatrixArtikel
        });
    }

    getSelectedImage(artikelBild: ArtikelBild.IArtikelBildDto) {
        this.selectedImgFile = artikelBild.bild;
    }

    onShowStaffel() {
        console.log(this.artikel.staffelpreise);
        $('#view_staffelpreise').toggleClass('visible');
        
        //Bereich mit Staffelpreisen aus this.Artikel.Staffelpreise... füllen
        if ($('#view_staffelpreise').hasClass('visible')) {
            
            //$('#view_staffelpreise').html(this.artikel.staffelpreise);
            var json_staffelpreise = JSON.parse(this.artikel.staffelpreise);

            console.log(json_staffelpreise);

            if (json_staffelpreise.length > 0) {
                var res_html = '<div>';

                res_html += "<div class='cnt_staffelpreis_header'>";
                res_html += "<div class='col_staffelpreis_h range'>Menge</div>";
                res_html += "<div class='col_staffelpreis_h netto'>Preis netto</div>";
                res_html += "<div class='col_staffelpreis_h brutto'>Preis brutto</div>";
                res_html += "</div>";

                for (let i = 0; i < json_staffelpreise.length; i++) {

                    res_html += "<div class='cnt_staffelpreis'>";
                    res_html += "<div class='col_staffelpreis range'>" + json_staffelpreise[i].Von + "-" + json_staffelpreise[i].Bis + "</div>";
                    res_html += "<div class='col_staffelpreis netto'>" + parseFloat(json_staffelpreise[i].Netto).toFixed(2) + " €</div>";
                    res_html += "<div class='col_staffelpreis brutto'>" + parseFloat(json_staffelpreise[i].Brutto).toFixed(2) + " €</div>";
                    res_html += "</div>";

                }

                res_html += '</div>';

                //console.log(res_html);

            }

            $('#view_staffelpreise').html(res_html);

        }
    }

    getvaluefromstaffel(menge) {
        //wenn staffelpreis vorhanden --> werte rausziehen und in Maske schreiben
        var json_staffelpreise = JSON.parse(this.artikel.staffelpreise);

        if (json_staffelpreise.length > 0) {

            for (let i = 0; i < json_staffelpreise.length; i++) {
                
                if (menge >= json_staffelpreise[i].Von && menge <= json_staffelpreise[i].Bis)
                    {
                        this.artikel.anzeigeNetto = json_staffelpreise[i].Netto;
                        this.artikel.anzeigeBrutto = json_staffelpreise[i].Brutto;
                    }

            }

        }
    }

}